import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled(motion.div)<{ $isActive?: boolean; $isMainButton?: boolean; $isChild?: boolean }>`
    a,
    button {
        display: flex;
        gap: 8px;
        user-select: none;
        width: 100%;

        font-weight: 700;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: -0.4px;
        color: rgba(255, 255, 255, 0.5);
        text-align: left;

        border: none;
        cursor: pointer;

        height: 42px;

        border-radius: 10px;

        display: flex;
        align-items: center;

        transition:
            color 0.1s ease-in-out,
            box-shadow 0.1s ease-in-out;

        &:hover {
            color: #fff;
        }

        &:active {
            color: #fff;
        }

        span {
            opacity: 0.5;
            font-weight: 500;
            border: 1px solid red;
        }

        ${({ $isMainButton }) =>
            $isMainButton
                ? css`
                      padding: 20px 20px;
                      height: 68px;

                      border-top: 1px solid rgba(255, 255, 255, 0.05);
                      border-radius: 0;
                  `
                : css`
                      padding: 0 12px;
                      background: rgba(255, 255, 255, 0.03);
                      &:hover {
                          color: #fff;
                          box-shadow:
                              0 0 68px 0 rgb(255 255 255 / 5%) inset,
                              0 0 0 1px rgb(255 255 255 / 5%) inset;
                      }
                  `}
    }

    ${({ $isChild }) =>
        $isChild &&
        css`
            a,
            button {
                padding-left: 30px;
            }
        `}

    ${({ $isActive }) =>
        $isActive &&
        css`
            a,
            button {
                color: #fff;
                background: linear-gradient(
                    91.77deg,
                    #e3ae59 -34.76%,
                    #90424c -10.86%,
                    #442753 79.81%,
                    #242135 115.58%
                );
            }
        `}
`;

export const Text = styled.div`
    flex-grow: 1;
    width: 100%;
    display: flex;
    gap: 8px;
`;

export const Count = styled.div`
    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #ffffff;

    padding: 2px 6px;

    background: rgba(255, 255, 255, 0.05);
    border-radius: 31px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
`;

export const IconLink = styled.div<{ $isActive?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;

    user-select: none;
    width: 46px;
    height: 46px;

    border: none;

    background: rgba(255, 255, 255, 0.03);
    border-radius: 10px;

    color: #fff;

    transition:
        color 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out,
        background 0.2s ease-in-out;

    &:hover {
        color: #fff;
        box-shadow:
            0 0 68px 0 rgb(255 255 255 / 5%) inset,
            0 0 0 1px rgb(255 255 255 / 5%) inset;
    }

    &:active {
        color: #fff;
    }

    ${({ $isActive }) =>
        $isActive &&
        css`
            color: #fff;
            background: linear-gradient(91.77deg, #e3ae59 -34.76%, #90424c -10.86%, #442753 79.81%, #242135 115.58%);
        `}
`;
